import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { forEach } from 'lodash-es';
import { BehaviorSubject, Subject } from 'rxjs';
import { ThemeService } from '../../shared/theme/services/theme.service';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {

  public changeSectionClass: BehaviorSubject<string>;
  public addSectionClass: Subject<string>;
  public disableBackgroundVideo: Subject<boolean>;
  public overrideActive: BehaviorSubject<boolean>;

  private disableBackground: boolean = false;

  /**
   * Constructor
   *
   * @param {Router} router
   * @param {ThemeService} themeService
   */
  public constructor(private router: Router, private themeService: ThemeService) {
    this.overrideActive = new BehaviorSubject(false);
    this.changeSectionClass = new BehaviorSubject<string>(null);
    this.addSectionClass = new Subject<string>();
    this.disableBackgroundVideo = new Subject<boolean>();
  }

  /**
   * Update the background, disabling it and any animations if needed.
   *
   * @return void
   */
  public updateBackground(): void {
    let disableBackgroundAfterUpdate: boolean = this.disableBackground;

    const theme = this.themeService.theme;

    const disabledUrls = ['world/exam', 'video'];
    forEach(disabledUrls, (item: string) => {
      if (this.router.routerState.snapshot.url.includes(item)) {
        if (item === 'world/exam') {
          disableBackgroundAfterUpdate = (theme === 'investigators');
        } else {
          disableBackgroundAfterUpdate = true;
        }

        if (disableBackgroundAfterUpdate) {
          return false;
        }
      }
    });

    this.disableBackgroundVideo.next(disableBackgroundAfterUpdate);
  }
}
